import { PUBLIC_HOST } from '@config/index';
import { IGeoData } from '@typescript/index';
import { fetcher } from '@utils/fetcher';

class NextGeoApi {
  public endpoints = {
    getRegions: () => `geoData`,
  };

  private static regionsFetcher = (url: string, options: Record<string, string>) => {
    const headers = {
      'content-type': 'application/json',
    };

    return fetcher(`${PUBLIC_HOST}/api/${url}`, {
      ...options,
      headers,
    });
  };

  public async getGeoData(): Promise<IGeoData> {
    const { json } = await NextGeoApi.regionsFetcher(this.endpoints.getRegions(), { method: 'GET' });

    return json;
  }
}

export default new NextGeoApi();
